// extracted by mini-css-extract-plugin
module.exports = {"popup":"OverlayingPopup_popup__f1wrJ","popup__overlay":"OverlayingPopup_popup__overlay__KhY8J"};